import { useOptionalPathTenantId } from "@/hooks/use-path-params";

import { SideNavItemPlaceholderManagement } from "./side-nav-item-placeholder-management";
import { SideNavItemTenantManagement } from "./side-nav-item-tenant-management";
import { TenantNavigation } from "./tenant-navigation";

/**
 * URL の構造とナビを 1 対 1 に対応させる。
 *
 * テナント配下にいるかどうかで、見えている世界そのものが変わる。
 */
export const SideNavigation = () => {
  const tenantId = useOptionalPathTenantId();

  if (tenantId) {
    return <TenantNavigation tenantId={tenantId} />;
  }

  return (
    <ul className="flex h-full flex-col gap-2">
      <li>
        <SideNavItemTenantManagement />
      </li>
      <li>
        <SideNavItemPlaceholderManagement />
      </li>
    </ul>
  );
};
